import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Params } from '@angular/router';

import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserDetailsService {


  constructor(private http: HttpClient) {}

  getShowcases(): Observable<any> {
    const url = environment.apiURL +`api/cinejoy/showcases`;
    return this.http.get(url);
  }

  getUserDetails(id): Observable<any> {
    const url = environment.apiURL +`api/user-profile/${id}`;
    return this.http.get(url);
  }

}
